import { NEW_TABLE, ERROR, LATEST_CUPPINGS, LOGOUT_USER, USER_TABLE_CUPPINGS, UPDATE_CUPPING, UPDATE_TABLE, SINGLE_TABLE, SINGLE_CUPPING, DELETE_TABLE, DELETE_CUPPING} from '../actions/types'

const defaultState = {
    saveOk: null,
    singleCupping: null,
    table: null,
    tableCuppings: null,
    latestCuppings: false,
    singleTable: null,
    error: false,
    error_msg: null
  }

function cuppingsReducer(prevState=defaultState, action){
    // console.log("ORIGINAL CUPPINGS", prevState, action)

    switch(action.type){
      case NEW_TABLE:
        return {...prevState, table: action.payload, singleTable: action.payload, error: false, error_msg: null}
      case LATEST_CUPPINGS:
        return {...prevState, latestCuppings: action.payload}  
      case LOGOUT_USER:
          return {...defaultState}
      case USER_TABLE_CUPPINGS:
          return {...prevState, tableCuppings: action.payload}
      case SINGLE_TABLE:
          return {...prevState, singleTable: action.payload}          
      case SINGLE_CUPPING:
          return {...prevState, singleCupping: action.payload}    
      case UPDATE_TABLE:
          return {...prevState, singleTable: action.payload}
      case UPDATE_CUPPING:
          return {...prevState, singleCupping: action.payload}
      case DELETE_TABLE:
          return {...prevState, singleTable: null, 
            latestCuppings: prevState.latestCuppings ? prevState.latestCuppings.filter(cuppingTable => {
              return cuppingTable.id !== action.payload.id }) : null, 
            }
      case DELETE_CUPPING:
          return {...prevState, singleCupping: null, 
              tableCuppings: prevState.tableCuppings ? prevState.tableCuppings.filter(cupping => {
                  return cupping.id !== action.payload.cuppingId }) : null,
              singleTable: {...prevState.singleTable,
                  num_coffees: prevState.singleTable.num_coffees - 1 }
                }
      case ERROR:
        return  {
          ...prevState,
          error: true,
          error_msg: action.payload,
        }  
      default: 
        return {...prevState, error: false}
    }
  
  }


    export default cuppingsReducer    
  
